export const LANG_CHECK = 'LANG_CHECK';
export const LANG_SET   = 'LANG_SET';

